<script>
import DibbleTranslation from "../../translation/translation";
import DibbleJS from "../../dibble";
import Vue from "vue";
import VueRouter from "vue-router";
import DibbleAPI from "../../api";
import DibbleApi from "../../api";
import ModalAddNewBoat from "./ModalAddNewBoat";
import UpComingEvents from "./UpComingEvents";
import UserMenuRoleModuleAssignment from "../../utils/UserMenuRoleAssignments";
import RentalReportModal from "../Rental/ReportModal/RentalReportModal";
import UserRoles from '../../DefinedData/UserRoles';
import AvailableBoatNumberModal from '../Rental/AvailableBoatNumberModal/AvailableBoatNumberModal.vue';

Vue.use(VueRouter);

export default {
    name: "BoatTypeInfo",
    components: { ModalAddNewBoat, UpComingEvents, RentalReportModal, AvailableBoatNumberModal },

    data() {
        return {
            roleAssignment: UserMenuRoleModuleAssignment,
            id: this.$route.params.id,
            translate: DibbleTranslation,
            dibbleJs: DibbleJS,
            boat: null,
            boatStatus: [],
            isAddingNewBoatStatus: false,
            isShowReportModal: false,
            isShowAvaiBoatNumModal: false
        };
    },
    computed: {
        isAdminRole() {
            return this.$cookies.get('_user')?.role === UserRoles.ADMIN
        }
    }
    ,
    created() {
        this.loadBoatType()
    },
    methods: {
        loadBoatType() {
            const params = {
                request: DibbleAPI.api.adminGetBoatTypeInfo,
                boat_type: this.id
            }
            DibbleJS.callApiRequest(params, this._onLoadBoatTypeSuccess, this._onLoadBoatTypeFailed)
        },
        showAddNewBoatStatus() {
            this.isAddingNewBoatStatus = true
        },
        cancelNewBoatStatus() {
            this.isAddingNewBoatStatus = false
        },
        showUpdateBoatStatus(boat) {
            this.isAddingNewBoatStatus = true
            this.$emit('setBoatData', boat);
        },
        handleModalListener(eventStr) {
            switch (eventStr) {
                case 'reload':
                    this.isAddingNewBoatStatus = false
                    this.loadBoatType();
                    break;
            }
        },
        _onLoadBoatTypeSuccess(response) {
            DibbleJS.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                this.boat = response
                if (!this.boatStatus.length) {
                    for (const i in response.boat_statuses) {
                        this.boatStatus.push({
                            id: parseInt(i),
                            text: response.boat_statuses[i]
                        })
                    }
                }
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        },
        isBoatStatusEditable(statusText) {
            if (!this.roleAssignment.isRoleHasWritePermission('Rental')) {
                return false
            }

            let editableStatus = null
            for (const i in this.boat['boat_statuses_with_action']) {
                if (this.boat['boat_statuses_with_action'][i].name.trim().toLowerCase() === statusText.trim().toLowerCase()) {
                    editableStatus = this.boat['boat_statuses_with_action'][i]
                    break
                }
            }

            return editableStatus
                ? editableStatus['is_action']
                : false
        },
        getBoatStatusAction(statusText) {
            let boatStatusAction = null;
            for (const i in this.boat['boat_statuses_with_action']) {
                if (this.boat['boat_statuses_with_action'][i].name.trim().toLowerCase() === statusText.trim().toLowerCase()) {
                    boatStatusAction = this.boat['boat_statuses_with_action'][i]
                    break
                }
            }

            return boatStatusAction;
        },
        updateBoatTypeStatus(boatId, statusId) {
            DibbleJS.confirmBox('Update Boat Status?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    request: DibbleApi.api.updateRentalBoatStatus,
                    boat_id: boatId,
                    status: statusId
                }, (response) => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message)
                        this.loadBoatType()
                        this.$refs.upComingEvents.loadOrderHistories(true)
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                }, this._onLoadBoatTypeFailed)
            })
        },
        _onLoadBoatTypeFailed(error) {
            DibbleJS.hideLoader();
            console.log(error)
            DibbleJS.toastErrorMessage('Something wrong! can not load data');
        },
        toggleReportModal() {
            this.isShowReportModal = !this.isShowReportModal
        },
        onBoatNumChange() {
            this.isShowAvaiBoatNumModal = true
        },
        onAvailableBoatNumberSaved() {
            this.isShowAvaiBoatNumModal = false
            this.loadBoatType()
        },
        handleGetTextColor(text) {
            const listObj = [
                {
                    text: 'On rent',
                    color: '#2C94AB'
                },
                {
                    text: 'In repair',
                    color: '#FC9C2B'
                },
                {
                    text: 'Not active',
                    color: '#CF132A'
                }, {
                    text: 'On hold',
                    color: '#7C7C7A'
                }
            ]
            const index = listObj.findIndex(el => el.text === text)
            if (index > -1) {
                return listObj[index].color
            }
            return '#1C5169'
        }
    },
}
</script>
<template src="./template/boat-type-info.html"></template>
<style lang="scss" scoped>
#add-new-boat-status {
    border-top: 1px solid #ccc
}

div.status-edit {
    cursor: pointer !important;
}

.rental-boat-info {
    display: flex;
    width: 100%;
    padding: 20px 30px;
    min-width: 1000px;

    p {
        font-family: 'Open Sans';
        font-style: normal;
    }

    .first-session {
        flex: 1;

        .header-boat-info {
            display: flex;
            justify-content: space-between;

            .title-boat {
                font-weight: 700;
                letter-spacing: 0.04em;
                text-transform: capitalize;
                color: #1C5169;
                font-size: 22px;
            }

            .toggle-button {
                width: 220px;
                background: #DFDFDF;
                display: flex;
                justify-content: space-evenly;
                opacity: 0.7;
                box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                border-radius: 30px;

                p {
                    font-size: 18px;
                    color: #7C7C7A;
                    width: 50%;
                    text-align: center;
                    padding: 10px 0px;
                    font-weight: 600;
                    font-size: 18px;
                    border-top-left-radius: 30px;
                    border-bottom-left-radius: 30px;
                    cursor: pointer;
                }

                .active-button {
                    background: #D9D9D9 !important;
                    color: #2C94AB;
                }
            }
        }

        .boat-content {
            display: flex;
            flex-direction: column;
            background: #F3F6F7;
            box-shadow: 0px 15px 20px -6px rgba(16, 24, 40, 0.15);
            border-radius: 40px;

            .introduction-boat {
                display: flex;
                width: 100%;

                .text-introduction {
                    flex: 1;
                    padding: 10px 0px;
                    font-weight: 400;
                    font-size: 16px;
                    color: #1C5169;
                    border-bottom: 1.5px solid #DEE6EA;
                    margin: 0px 20px;
                }
            }

            .boat-info {
                width: 50%;
                height: auto;
                display: flex;
                flex-direction: column;
                cursor: pointer;


                .boat-header {
                    height: 190px;
                    background-position: center;
                    background-size: cover;
                    border-top-right-radius: 40px;

                    .boat-title {
                        width: 90%;
                        height: 43px;
                        background: #1C5169;
                        opacity: 0.8;
                        box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                        border-radius: 0px 25px 25px 0px;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 600;
                        font-size: 18px;
                        line-height: 22px;
                        color: #FFFFFF;
                        padding-left: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;


                        strong {
                            font-weight: 600;
                            font-size: 18px;
                            color: #fff;
                            padding-right: 10px;
                        }

                        .people-statistic {
                            display: flex;
                            align-items: center;

                            .line-vertical {
                                height: 43px;
                                width: 1.5px;
                                background: #52B9D0;
                                margin-right: 15px;
                            }

                            p {
                                font-weight: 600;
                                font-size: 18px;
                                color: #52B9D0;
                                padding-right: 5px;
                            }
                        }
                    }
                }


            }

            .boat-optimize {
                display: flex;
                border-bottom: 1.5px solid #DEE6EA;
                margin: 0px 20px;

                .title {
                    font-weight: 700;
                    color: #2C94AB;
                }

                p {
                    font-size: 16px;
                    color: #555E67;
                }

                .boat-inform {
                    width: 50%;
                    margin-bottom: 20px;
                }

                .boat-prices {
                    width: 50%;
                    margin-bottom: 20px;
                    padding: 0px 20px;
                }

                .note-price {
                    width: 80px;
                }
            }

            .list-btn {
                display: flex;
                margin: 0px 20px;
                padding: 20px 0px;
                border-bottom: 1.5px solid #DEE6EA;

                .first {
                    flex: 1;
                    display: flex;
                    align-items: center;

                    p {
                        font-weight: 700;
                        font-size: 16px;
                        color: #2C94AB;
                    }

                    img {
                        cursor: pointer;
                        margin-left: 10px;
                    }
                }

                .second {
                    width: 50%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    button {
                        padding: 10px 30px;
                        background: #2C94AB;
                        box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                        border-radius: 100px;
                        font-weight: 600;
                        font-size: 16px;
                        text-align: center;
                        color: #FFFFFF;
                        outline: none;
                        border: none;

                        &:not(:nth-child(1)) {
                            margin-left: 10px;
                        }
                    }
                }
            }

            .boats-status {
                margin: 0px 20px;
                padding: 20px 0px;

                .title-status {
                    font-weight: 700;
                    font-size: 16px;
                    text-transform: capitalize;
                    color: #2C94AB;
                }

                .status-boat-option {
                    display: flex;

                    .name-boat {
                        width: 10%;
                        margin-right: 5%;

                        p {
                            font-weight: 700;
                            font-size: 14px;
                            color: #1C5169;
                            letter-spacing: 0.01em;
                            cursor: pointer;
                        }
                    }

                    .list-status {
                        flex: 1;
                        display: flex;
                        justify-content: space-between;

                        .btn-status {
                            width: 19%;
                            background: #C2D8DD;
                            box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
                            border-radius: 20px;
                            padding: 10px 10px;
                            text-align: center;
                            font-weight: 600;
                            font-size: 14px;
                            color: #1C5169;
                        }

                        .text-on-rent {
                            color: #2C94AB !important;
                        }

                        .text-in-repair {
                            color: #FC9C2B !important;
                        }

                        .text-not-active {
                            color: #CF132A;
                        }

                    }
                }
            }
        }

        .line-through {
            width: 100%;
            margin: 20px;
            height: 1.5px;
            background: #DEE6EA;
        }
    }

    .second-session {
        width: 30%;
        margin-left: 5%;
    }
}
</style>
